
import { ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext } from "@/script/core/base/ServiceData";
import {
  createNodeContext,
  createReconContext,
} from "@/script/apps/recon/config/ReconConfig";
import { Recon, ReconItem } from "@/script/apps/recon/entity/ReconEntity";
import { DictUtil } from "@/script/core/Dict";
import { ReconService } from "@/script/apps/recon/service/ReconService";
import { AppConfig } from "@/script/core/base/AppConfig";

@Options({})
export default class ReconReport extends BaseList {
  private queryEntity: Recon = {};
  private dataList: ReconItem[] = [];
  private nodeList: Node[] = [];
  private dateRange: string[] = [];

  public initData(): ServiceContext {
    this.tableHeight = this.tableHeight! + 40;
    return createReconContext();
  }

  public initQueryEntity() {
    this.queryEntity = {
      name: "",
    };
    return this.queryEntity;
  }

  protected initOptions() {
    super.initOptions();
    createNodeContext().service.loadFullList<Node[]>((data: Node[]) => {
      this.nodeList = data;
    });
  }

  public loadList() {
    if (this.queryEntity.state === "") {
      this.queryEntity.state = null;
    }
    if (this.dateRange && this.dateRange.length > 0) {
      this.dateRange[1] = this.dateRange[1].replace("00:00:00", "23:59:59");
      this.queryParam.extendMap = {
        beginTime: this.dateRange[0],
        endTime: this.dateRange[1],
      };
    } else {
      this.queryParam.extendMap = {};
    }

    (this.serviceContext.service as ReconService)
      .loadReconDetailList(this.queryParam)
      .then((response) => {
        const url = new URL(AppConfig.Config.ServerUrl);
        response.data.list.forEach((item: ReconItem) => {
          item.picPath =
            "http://" + url.hostname + "/app-cruise" + item.picPath;
        });
        this.wrapList(this, response.data);
        this.dataList = response.data.list;
      })
      .catch((error) => {
        ElMessage.error(error.message);
      });
  }

  public afterLoadList(data: any): void {}
}
